import { NonprofitOrgUser, FunderUser } from 'TypeDefs/Team'
import { NonprofitOrgToUserRole } from 'Generated/graphql-types'

export const orderUsers = (
  users: NonprofitOrgUser[] | FunderUser[]
): (NonprofitOrgUser | FunderUser)[] => {
  const owner = users.find((user) => user.role === NonprofitOrgToUserRole.Owner)

  const joinedUsers = users.filter(
    (user) =>
      user.user.firstName &&
      user.user.lastName &&
      user.role !== NonprofitOrgToUserRole.Owner
  )

  const unjoinedUsers = users.filter(
    (user) => !user.user.firstName && !user.user.lastName
  )

  joinedUsers.sort((a, b) => {
    if (a.user.lastName && b.user.lastName) {
      return a.user.lastName.localeCompare(b.user.lastName)
    }
    return 0
  })

  unjoinedUsers.sort((a, b) => a.user.email.localeCompare(b.user.email))

  return owner
    ? [owner, ...joinedUsers, ...unjoinedUsers]
    : [...joinedUsers, ...unjoinedUsers]
}
